//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import domtoimage from 'dom-to-image'
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: 'Viewer',
  props: {
    product: {required: true},
    stones: {required: true},
    photoJewelrySettings: {},
    photoJewelryEngravings: {required: false},
    showSample: {
      required: true,
      default: true
    }
  },

  data() {
    return {
      backSideImageSuffix: '_BACK',
      viewSideCode: 'FRONT',
    }
  },

  computed: {
    ...mapGetters('frontend/productDetail',['getIsLoadingImage']),
    stonePositions() {
      if (
        Object.keys(this.stones[this.product.StoneNr].Position) &&
          Object.keys(this.stones[this.product.StoneNr].Position)[0] &&
        !Object.keys(this.stones[this.product.StoneNr].Position)[0].includes(
          '_'
        )
      ) {
        return this.stones[this.product.StoneNr].Position
      } else {
        const filtered = Object.keys(this.stones[this.product.StoneNr].Position)
          .filter((key) => key.split('_')[1] == 1)
          .reduce((obj, key) => {
            obj[key] = this.stones[this.product.StoneNr].Position[key]
            return obj
          }, {})
        return filtered
      }
    },
    ItemIsEngravable() {
      return (
        this.product.IsEngravable && this.product.FormData.ENGRAVABLE.Value == 1
      )
    },
    apiRootUrl() {
      return this.$config.axios.browserBaseURL.replace('api/', '')
    },
    backSideImageUrl() {
      if (!this.photoJewelrySettings || !this.photoJewelrySettings.hasTwoSides) {
        return ""
      }
      const imageName = this.product.ImageURL
      const image = imageName.substring(
          imageName.lastIndexOf(".")
      )
      return this.product.ImageURL.replace(image, '') + this.backSideImageSuffix + image
    }
  },
  methods: {
    ...mapMutations('frontend/productDetail', ['setIsLoadingImage']),
    getStartOffset(key, startOffset, isSecondText, isMiddle) {
      let lstartOffset = startOffset
      if (this.product.FormData.CS) {
        if (key.includes('_')) key = key.split('_')[0]
        const stonePositionAndID = Object.keys(this.product.FormData.CS).filter(
          (id) => id.split('_')[0] == key
        )
        const stoneID = stonePositionAndID[0]
        if (this.product.FormData.CS[stoneID]) {
          const multiplier = isMiddle ? 5 : 7.5
          const lText =
            isSecondText == false
              ? this.product.FormData.CS[stoneID].SecondValue
              : this.product.FormData.CS[stoneID].ThirdValue
          if (startOffset > 0) {
            lstartOffset = lText
              ? startOffset - lText.length * multiplier
              : startOffset - 6 * multiplier
            lstartOffset = lstartOffset < 0 ? lstartOffset * -0.2 : lstartOffset
          } else {
            lstartOffset = startOffset * -1
          }
        }
      }

      return lstartOffset
    },
    getPathID(index, includeHashtag) {
      return includeHashtag == true ? '#curve' + index : 'curve' + index
    },
    getTextLength(key, maxLength, isSecondText) {
      let lLength = 20
      if (this.product.FormData.CS) {
        if (key.includes('_')) key = key.split('_')[0]
        const stonePositionAndID = Object.keys(this.product.FormData.CS).filter(
          (id) => id.split('_')[0] == key
        )
        const stoneID = stonePositionAndID[0]
        lLength = 6 * (maxLength / 9)
        if (this.product.FormData.CS[stoneID]) {
          const lText =
            isSecondText == false
              ? this.product.FormData.CS[stoneID].SecondValue
              : this.product.FormData.CS[stoneID].ThirdValue
          lLength = lText ? lText.length * (maxLength / 9) : lLength
        }
      }

      return lLength > 0 ? lLength : 20
    },
    StoneHasTwoEngraving(item) {
      return item && item.text_startOffset2 != undefined
    },
    updateEngraving(key, isSecondText, fontCase) {
      var lSampleText = this.showSample ? (fontCase == "lower" ? "Sample" : "SAMPLE") : " " ;
      if (this.product.FormData.ENGRAVINGS && parseInt(this.product.StoneNr) <= 0){

        return this.product.FormData.ENGRAVINGS.ValueArray[key]
      }

      if (this.product.FormData.CS) {
        if (key.includes('_')) key = key.split('_')[0]
        const stonePositionAndID = Object.keys(this.product.FormData.CS).filter(
          (id) => id.split('_')[0] == key
        )
        const stoneID = stonePositionAndID[0]
        let lEngravingText = ''
        if (isSecondText == false) {
          lEngravingText =
            this.product.FormData.CS[stoneID] &&
            this.product.FormData.CS[stoneID].SecondValue
              ? this.product.FormData.CS[stoneID].SecondValue
              : lSampleText
        } else {
          lEngravingText =
            this.product.FormData.CS[stoneID] &&
            this.product.FormData.CS[stoneID].ThirdValue
              ? this.product.FormData.CS[stoneID].ThirdValue
              : lSampleText
        }
        return lEngravingText
      }
    },
    updateCoordiantes(event) {
      this.$parent.mousepointerX = event.layerX
      this.$parent.mousepointerY = event.layerY
    },
    getStyle(width, height, left, top, zIndex, transform) {
      return (
        'width: ' +
        width +
        ';height: ' +
        height +
        ';left: ' +
        left +
        ';top: ' +
        top +
        ';z-index:' +
        zIndex +
        (transform ? ';transform:' + transform : '')
      )
    },
    getImage(index, key) {
      if (this.product.FormData.CS) {
        let sameStoneAttribute = this.product.Product.CustomAttributes.find(
            (attribute) => attribute.Code === 'SAME_STONE'
        )
        let isSameStone = false

        if (sameStoneAttribute){
         isSameStone = sameStoneAttribute.ValueStr == "True"
        }
        if (key.includes('_')) key = key.split('_')[0]

        const stonePositionAndID = Object.keys(this.product.FormData.CS).filter(
          (id) => id.split('_')[0] == (isSameStone ? 1 : key)
        )

        if (stonePositionAndID && stonePositionAndID[0]) {
          let lStoneType = 'RDCS'
          if (this.product.Controls.filter((c) => c.name == 'CS').length > 0) {
            lStoneType = this.product.Controls.filter((c) => c.name == 'CS')[0]
              .GroupedOptions[(isSameStone ? 0 : key-1)].Code
          }

          const lStoneImageUrl = this.apiRootUrl + 'stones/' + lStoneType + '/'
          const lStoneCode = this.product.FormData.CS[stonePositionAndID[0]]
            .Value
          if (lStoneCode) {
            if (!lStoneCode.includes('DI') && lStoneCode.includes('&')) {
              return (
                lStoneImageUrl +
                lStoneCode.substr(0, lStoneCode.indexOf('&')) +
                '.png?v=' +
                this.$config.contentVersion
              )
            }
            return (
              lStoneImageUrl +
              (lStoneCode.includes('DI') ? 'DIA' : lStoneCode) +
              '.png?v=' +
              this.$config.contentVersion
            )
          } else {
            return lStoneImageUrl + 'WS.png'
          }
        }
      }
    },
    updateImage(callback) {
      this.viewSideCode = "FRONT"
      this.setIsLoadingImage(true)
      this.$nextTick(() => {
        domtoimage
          .toPng(this.$refs.captureDiv, {})
          .then((dataUrl) => {
            const productImg = this.$refs.ProductImage
            productImg.src = dataUrl
            this.setIsLoadingImage(false)

            if (callback) callback()
          })
          .catch((error) => {
            this.setIsLoadingImage(false)
            console.log('Error creating image: ', error)
          })
      })
    },
    /*
    PHOTO JEWELRY
    */
    updateBacksideImage(switchToFront = true) {
      if (this.photoJewelrySettings && this.photoJewelrySettings.hasTwoSides) {
        this.viewSideCode = "BACK"
        this.setIsLoadingImage(true)

        this.$nextTick(() => {
          let vm = this
          domtoimage
              .toPng(this.$refs.CaptureBackDiv, {})
              .then((dataUrl) => {
                const productBackImg = this.$refs.ProductBackImage
                productBackImg.src = dataUrl
                this.setIsLoadingImage(false)

                if (switchToFront) {
                  this.viewSideCode = "FRONT"
                }
              })
              .catch((error) => {
                this.setIsLoadingImage(false)
                console.log('Error creating image: ', error)
              })
        })
      }
    },
    onSwitchSide(sideCode) {
      this.viewSideCode = sideCode
    },
    updatePhotoJewelryEngraving(index) {
      if (this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS
          && this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS.ValueArray
          && this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS.ValueArray[index]
      ) {
        return this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS.ValueArray[index]
      }
    },
    updateGeneralEngraving(index){
      if (this.product.FormData.ENGRAVINGS
          && this.product.FormData.ENGRAVINGS.ValueArray
          && this.product.FormData.ENGRAVINGS.ValueArray[index]
          && parseInt(this.product.StoneNr) <= 0){
        return this.product.FormData.ENGRAVINGS.ValueArray[index]
      }
    },
  },
}
